/**
 * Notes shown on invoices: customer delivery_notes + driver completion_notes.
 */
export function getInvoiceDeliveryNotes(job) {
  if (!job) return '';
  const jobNotes = (job.delivery_notes || '').trim();
  const completionNotes = (job.delivery_completion?.completion_notes || '').trim();

  if (jobNotes && completionNotes) {
    if (jobNotes === completionNotes) return jobNotes;
    return `${jobNotes}\n\n${completionNotes}`;
  }
  return jobNotes || completionNotes || '';
}

/** Equipment count recorded when the driver completed the job. */
export function getJobEquipmentCount(job) {
  if (!job) return null;
  if (job.equipment_count != null && job.equipment_count !== '') {
    return job.equipment_count;
  }
  const fromCompletion = job.delivery_completion?.equipment_count;
  if (fromCompletion != null && fromCompletion !== '') {
    return fromCompletion;
  }
  return null;
}
